// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { ErrorIssueStatus } from "./Shared.ErrorIssueStatus.gen";
import { ErrorSeverity } from "./Shared.ErrorSeverity.gen";

export interface IErrorDetails {
	hashId: string | undefined;

	message: string | undefined;

	stackTrace: string | undefined;

	stackTraceFirmwareVersion: string | undefined;

	firstSeenAt: string | undefined;

	lastSeenAt: string | undefined;

	status: ErrorIssueStatus;

	resolvedInFirmwareVersion: string | undefined;

	severity: ErrorSeverity | undefined;

	notes: string | undefined;

	statusChangedByUserId: string | undefined;

	statusChangedAt: string | undefined;

	statusChangedByName: string | undefined;

	$type?: string | undefined;
}
export class ErrorDetails {
	constructor(data?: IErrorDetails) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.firstSeenAt) { this.firstSeenAt = new Date(data.firstSeenAt); }
		if (data.lastSeenAt) { this.lastSeenAt = new Date(data.lastSeenAt); }
		if (data.statusChangedAt) { this.statusChangedAt = new Date(data.statusChangedAt); }
	}

	hashId: string | undefined;

	message: string | undefined;

	stackTrace: string | undefined;

	stackTraceFirmwareVersion: string | undefined;

	firstSeenAt: Date | undefined = new Date();

	lastSeenAt: Date | undefined = new Date();

	status: ErrorIssueStatus = 0;

	resolvedInFirmwareVersion: string | undefined;

	severity: ErrorSeverity | undefined;

	notes: string | undefined;

	statusChangedByUserId: string | undefined;

	statusChangedAt: Date | undefined;

	statusChangedByName: string | undefined;

	static $type: string = "CoreApi.Models.ErrorDetails, ";
	$type?: string | undefined = ErrorDetails.$type;
}

